import { Icon } from "./Icon.tsx";

/** "Pollutants" tab icon — a droplet carrying a contaminant particle,
 * distinct from LidControlIcon.tsx's own plain droplet (clean rain
 * infiltrating a filter, not a pollutant in runoff). */
export function PollutantIcon() {
  return (
    <Icon>
      <path d="M12 3c4 5 7 8.5 7 12a7 7 0 0 1-14 0c0-3.5 3-7 7-12Z" />
      <circle cx="12" cy="15" r="1.3" fill="currentColor" stroke="none" />
    </Icon>
  );
}
